import axios from 'axios';
import {isError} from '@epic-mw/error-types';

interface Status {
    description?: string;
    indicator?: string;
}

interface Incidents {
    any;
}

export interface StatusResponse {
    status: Status;
    incidents: Incidents[];
}

class StatusApi {
    public async getStatus(epicStatusApi: string): Promise<StatusResponse> {
        try {
            const response = await axios(epicStatusApi);
            const data = response.data || {};
            const status = data.status || ({} as Status);
            const incidents = data.incidents || [];
            return {status, incidents};
        } catch (e) {
            console.error('getStatus() failed to load', isError(e) && e.message);
            throw e;
        }
    }
}

export const statusApi = new StatusApi();
